import React from 'react';
import { styled } from '@compiled/react';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import type { Flag } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ChangeTabType } from '@atlassian/jira-share-button/src/ui/types.tsx';
import { LazyShareToSlack } from './async.tsx';

type Props = {
	channel?: string;
	product: 'jira' | 'confluence';
	// eslint-disable-next-line jira/react/handler-naming
	showFlag: (arg1: Flag) => unknown;
	changeTab?: ChangeTabType;
	onClose: () => void;
	cloudId: string;
	shareContentType?: string;
};

export const ShareToSlack = (props: Props) => (
	<ErrorBoundary id="async-share-to-slack" packageName="integrations">
		<Placeholder name="share-to-slack" fallback={<StyledShareToSlackLoader />}>
			{/* @ts-expect-error - TS2322 - Type '{ channel?: string | undefined; product: "jira" | "confluence"; showFlag: (arg1: Flag) => unknown; changeTab?: any; onClose: () => void; cloudId: string; }' is not assignable to type 'Readonly<ThemedOuterStyledProps<WithOptionalTheme<FlagAPI & { product: AtlassianProduct; createSlackService?: ((product: AtlassianProduct) => SlackService) | undefined; cloudId: string; } & { ...; }, any>, any>>'. */}
			<StyledShareToSlack {...props} />
		</Placeholder>
	</ErrorBoundary>
);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as SlackIcon } from './slack-icon';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const StyledShareToSlackLoader = styled(Spinner)({
	width: '100%',
	margin: '0 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const StyledShareToSlack = styled(LazyShareToSlack)({
	marginTop: token('space.negative.200'),
	marginRight: token('space.negative.300'),
	marginBottom: token('space.negative.200'),
	marginLeft: token('space.negative.300'),
});
